module.exports = __webpack_public_path__ + "static/img/theme_3.8134ca4d.png";